import { useMemo } from "react";

import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import { slugify } from "@covertree/utils";
import { Modal } from "@covertree/ui";
import { UnderwritingDecision } from "@covertree/new-business-graphql";
import { colors } from "@covertree/theme/colors";
import { UW_EMAIL } from "@covertree/consts";

import { UW_NOTE_TOKENS } from "../../common/uwNoteTokens";
import { replaceTextTokens } from "../../utils/replaceTextTokens";

interface UnderwritingReasonsModalProps {
  open: boolean;
  reasons: string[];
  status: UnderwritingDecision;
  onClose: () => void;
}
export function UnderwritingReasonsModal({
  open,
  status,
  reasons,
  onClose,
}: UnderwritingReasonsModalProps) {
  const isStatusRejected = useMemo(() => {
    return status === UnderwritingDecision.Reject;
  }, [status]);

  return (
    <Modal title="Reason" open={open} onClose={onClose} maxWidth="md">
      <Box mb={3}>
        {isStatusRejected ? (
          <Typography component="p">
            Quote has been rejected due to the following reason&#40;s&#41;:
          </Typography>
        ) : (
          <>
            <Typography>
              Please contact CoverTree underwriting at{" "}
              <Typography
                component="span"
                fontWeight="bold"
                color={colors.green3}>
                {UW_EMAIL}
              </Typography>{" "}
            </Typography>
            <Typography>
              to further process the quote due to the following
              reason&#40;s&#41;:
            </Typography>
          </>
        )}
      </Box>
      {reasons.length === 0 && (
        <Grid container justifyContent="center">
          <Grid item>
            <CircularProgress color="secondary" />
          </Grid>
        </Grid>
      )}
      <Box component="ul">
        {reasons.map((reason) => (
          <Box key={slugify(reason)} component="li">
            {replaceTextTokens(reason, UW_NOTE_TOKENS)}
          </Box>
        ))}
      </Box>
    </Modal>
  );
}
